<template>
  <div class="content-container">
    <a-menu mode="horizontal" :selectedKeys="activeKey" class="menu" @select="onChange">
      <a-menu-item v-for="item in menuList" :key="item.text">
        {{ item.text }}
      </a-menu-item>
    </a-menu>
    <div class="content">
      <tome v-if="activeKey[0] === menuList[0].text"></tome>
      <me v-if="activeKey[0] === menuList[1].text"></me>
    </div>
  </div>
</template>
<script>
import me from './components/clue/me.vue';
import tome from './components/clue/tome.vue';
export default {
  components: {
    me,
    tome
  },
  data() {
    let menuList = [
      {
        text: '推荐给我的'
      },
      {
        text: '我推荐的'
      }
    ];
    return {
      activeKey: [menuList[0].text],
      menuList
    };
  },
  methods: {
    onChange(option) {
      console.log(option);
      this.activeKey = option.selectedKeys;
    }
  }
};
</script>
<style lang="less" scoped>
@media only screen and (min-width: 800px) {
  .menu {
    // display: flex;
    // justify-content: center;
    // border: none;
    margin-bottom: 40px;
  }
  .content-container {
    margin-top: -50px;
  }
}
@media only screen and (max-width: 800px) {
  .content-container {
    margin-top: -20px;
  }
}

/deep/.ant-menu-item {
  font-size: 12px;
}
</style>
